<template>
  <b-form-select v-model="aggregateFunction">
    <b-form-select-option v-for="fn of aggregateFunctions" :value="fn.name">
      {{ fn.display || `${fn.name}()` }} - {{ fn.description }}
    </b-form-select-option>
  </b-form-select>
</template>

<script>

export default {

  name: 'AggregateFunctionSelect',

  components: {
  },

  inject: [
    /* Utility functions etc. [from CalculationModel] */
    'entityUtils',
  ],

  props: {
    /** Field to be aggregated - restricts available functions. */
    aggregationField: {
      type: Object|null,
      required: true,
    },
    /** Selected Aggregate function. */
    value: {
      type: String | null,
      required: true,
    },
  },

  data() {
    return {
      aggregateFunctions: [],//this.entityUtils.aggregateFunctions,
    };
  },

  computed: {

    /** Selected Function. */
    aggregateFunction: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },

  },

  watch: {

    aggregationField: {
      handler(newVal) {
        // Repopulate aggregate functions.
        this.aggregateFunctions =
          this.entityUtils.aggregateFunctions.filter(fn =>
            // Allow function if already referenced.
            fn.name == this.aggregateFunction ||
            // Filter out functions that are not applicable to the current aggregation field.
            (newVal && this.entityUtils.fieldAllowsAggregateFunction(newVal, fn.name))
          );
        // Clear function if no longer available.
        if (!this.aggregateFunctions.find(fn => fn.name == this.aggregateFunction))
          this.aggregateFunction = '';
      },
      immediate: true,
    },

  },

  methods: {},

  async beforeMount() { },

};

</script>

<style scoped></style>